<div class="container-fluid">
    <app-submenu-tabs section="ALIGNMENT"></app-submenu-tabs>
    <router-outlet></router-outlet>    
</div>